import React from "react";

const TagPlaceholder = ({ tag }) => {
  const tagPlaceholderStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 10,
    width: "100%",
    minHeight: 104,
    textAlign: "center",
  };

  return (
    <div css={tagPlaceholderStyle}>
      <p>Placeholder for video tagged with <strong>{tag}</strong> tag from subscriber showcase.</p>
    </div>
  );
};

export default TagPlaceholder;
